// extracted by mini-css-extract-plugin
module.exports = {"content":"antd-pro-components-page-header-wrapper-index-content"};